import { EventEmitter } from 'events';
import { Action } from 'redux';

import version from '../browser/appversion';
import { IConfig } from '../browser/IConfig';

import LOGIN from '../auth/actions/LOGIN';
import LOGOUT from '../auth/actions/LOGOUT';
import CONFIG from '../browser/actions/CONFIG';
import NOTES_REDRAW from '../note/notes/actions/NOTES_REDRAW';

export class BrowserProxy extends EventEmitter {
    public constructor(
        private readonly _isVisible: () => boolean,
        private readonly _dispatch: (action: Action) => void,
    ) {
        super();
    }

    public get version() {
        return version;
    }

    public get visible() {
        return this._isVisible();
    }

    public login() {
        this._dispatch(LOGIN({}));
    }

    public logout() {
        this._dispatch(LOGOUT({ }));
    }

    public config(config: IConfig) {
        this._dispatch(CONFIG(config));
    }

    public redrawNotes() {
        this._dispatch(NOTES_REDRAW({}));
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/browserProxy/BrowserProxy.tsx